<template>
<!-- <div id="sticky-nav" class="wrapper" > -->
<div class="wrapper-nav linebottomg" :style="`top:${navH}px`" >
  <!-- <div class="count-down-num" > -->
    <div class="tabs-wrapper">
        <div
          v-for="(item, index) of titleList"
          :key="index"
          @click="clickSingle(item,index) "
          :class="['tab', tabSelectItem === item ? 'tab-selected' : '']"
          :id="`navSelectView${index}`"
        >
        {{item}}
        <div
        id="navSelectView"
        :class="['tabB', tabSelectItem === item ? 'tabB-selected' : '']"></div>
        </div>
      </div>
      <transition name="slide-fade-NGuide">
      <div class="userNGuide"
      v-if="labGUIShow"
      :style="`left:${labGUILeft}px;top:${labGUITop}px`">
        <div class="userNGuideTri" ></div>
        <div class="userNGuideCont" >
          <span
          :class="[isIoS ? 'userNGuideText' : 'userNGuideText2']">点这里，快速定位到对应模块</span>
        </div>
        <div class="userNGuideSep" >
        </div>
      </div>
      </transition>
  </div>
</template>

<script>
import stickybits from 'stickybits';
import StoreManger from '@/utils/FundHQJHManger';
import Util from '@/base/Util';

export default {
  props: {
    titleList: {
      type: Array,
      default: () => ['行情', '档案', '持仓', '规则', '公告', '讨论'],
    },
    tabSelectItem: {
      type: String,
      default: '行情',
    },
  },
  // watch: {
  //   tabSelectItem(newVal) {
  //     if (newVal === '档案') {
  //       this.showGuide();
  //     }
  //   },
  // },
  created() {
    this.configureLayout();
    // #if EXECUTION_ENV === 'fund'
    // eslint-disable-next-line no-undef
    const systemInfo = fund.getSystemInfoSync();
    console.log(JSON.stringify(systemInfo));
    if (systemInfo) {
      if (systemInfo.system) {
        if (systemInfo.system.indexOf) {
          if (systemInfo.system.indexOf('iOS') !== -1) {
            this.isIoS = true;
          }
        }
      }
    }
    // #endif
  },
  mounted() {
    stickybits('#sticky-nav');
    this.needshowLJSYTip();
  },
  data() {
    return {
      tabSelectIndex: 0,
      navH: 88,
      // 指引
      labGUILeft: 50,
      labGUITop: 44,
      labGUIShow: false,
      isIoS: false,
    };
  },
  methods: {
    configureLayout() {
      this.navH = StoreManger.getNAVSTATEHEIGHT();
    },
    scrollToMaoDian(item) {
      // const cctop = document.querySelector('#jjFundPositions').offsetTop - 100;
      // let ccHoldtop = cctop + 300;
      // if (document.querySelector('#jjFundHoldFund')) {
      //   ccHoldtop = document.querySelector('#jjFundHoldFund').offsetTop;
      // }
      // const gztop = document.querySelector('#jjTrade').offsetTop - 100;
      // const ggtop = document.querySelector('#jjFundNews').offsetTop - 100;
      // const zxtop = document.querySelector('#jjFundComments').offsetTop;
      let maindian = 'Conjunc';
      if (item === '行情') {
        // 行情
        this.moveToTopView(0);
        return;
      }
      if (item === '档案') {
        // 持仓
        maindian = 'jjFundPositions';
      }
      if (item === '持仓') {
        // 持仓
        if (!document.querySelector('#jjFundHoldFund')) {
          const ccHoldtop = document.querySelector('#jjFundPositions').offsetTop + 150;
          this.moveToTopView(ccHoldtop);
          return;
        }
        maindian = 'jjFundHoldFund';
      }
      if (item === '规则') {
        // 持仓
        maindian = 'jjTrade';
      }
      if (item === '讨论') {
        // 持仓
        maindian = 'jjFundComments';
      }
      if (item === '资讯') {
        // 持仓
        maindian = 'jjFundNews';
      }
      if (item === '公告') {
        // 持仓
        maindian = 'jjFundNews';
      }
      let cctop = document.querySelector(`#${maindian}`).offsetTop - 54;
      if (cctop < 0) {
        cctop = 0;
      }
      this.moveToTopView(cctop);
    },
    moveToTopView(index) {
      console.log(index);
      if (window.pageYOffset) {
        // window.pageYOffset = index;
      }
      if (document.documentElement) {
        document.documentElement.scrollTop = index;
      }
      if (document.body) {
        document.body.scrollTop = index;
      }
    },
    getItemLink(item) {
      if (item === '行情') {
        // 行情
        return '#Conjunc';
      }
      if (item === '档案') {
        // 持仓
        return '#Positions';
      }
      if (item === '持仓') {
        // 持仓
        return '#HoldFund';
      }
      if (item === '规则') {
        // 持仓
        return '#Trade';
      }
      if (item === '讨论') {
        // 持仓
        return '#Comments';
      }
      if (item === '资讯') {
        // 持仓
        return '#news';
      }
      if (item === '公告') {
        // 持仓
        return '#news';
      }
      // 持仓
      return '#Conjunc';
    },
    getShowManagerState() {
      const state = Util.getTipGuideCache('ShowTopManagerState');
      if (state && state === '1') {
        return false;
      }
      return true;
    },
    setShowManagerState() {
      Util.setTipGuideCache('ShowTopManagerState', '1');
    },
    getShowLJSYzsTipState() {
      const state = Util.getCache('ShowTopLabTipState');
      if (state && state === '1') {
        return false;
      }
      return true;
    },
    setShowLJSYzsTipState() {
      Util.setCache('ShowTopLabTipState', '1');
    },
    hidLJSYzsTip() {
      if (this.labGUIShow) {
        this.setShowLJSYzsTipState();
        this.labGUIShow = false;
      }
    },
    // 自动消失
    autoHidLJSYzsTip() {
      setTimeout(() => {
        if (this.labGUIShow) {
          this.setShowLJSYzsTipState();
          this.labGUIShow = false;
        }
      }, 3000);
    },
    needshowLJSYTip() {
      if (this.getShowLJSYzsTipState()) {
        // 没展示过
        const ljsytipview = document.getElementById('navSelectView1');
        if (ljsytipview) {
          if (this.labGUIShow === false) {
            this.labGUIShow = true;
            const domRect = ljsytipview.getBoundingClientRect();
            this.labGUILeft = domRect.x + domRect.width / 2 - 62;
            this.setShowLJSYzsTipState();
            this.autoHidLJSYzsTip();
          }
        }
      }
    },
    showGuide() {
    },
    clickSingle(item, index) {
      this.hidLJSYzsTip();
      this.scrollToMaoDian(item);
      this.$emit('tipclick', item, index);
      this.tabSelectIndex = index;
      if (item === '行情') {
        // 行情
        this.reportMonitor({
          eventName: 'pz.label.hq',
          infoCodeType: '',
          infoCode: '',
        });
      }
      if (item === '档案') {
        // 持仓
        this.reportMonitor({
          eventName: 'pz.label.cc',
          infoCodeType: '',
          infoCode: '',
        });
      }
      if (item === '概况') {
        // 持仓
        this.reportMonitor({
          eventName: 'pz.label.gk',
          infoCodeType: '',
          infoCode: '',
        });
      }
      if (item === '讨论') {
        // 持仓
        this.reportMonitor({
          eventName: 'pz.label.tl',
          infoCodeType: '',
          infoCode: '',
        });
      }
      if (item === '资讯') {
        // 持仓
        this.reportMonitor({
          eventName: 'pz.label.yw',
          infoCodeType: '',
          infoCode: '',
        });
      }
      if (item === '公告') {
        // 持仓
        this.reportMonitor({
          eventName: 'pz.label.gg',
          infoCodeType: '',
          infoCode: '',
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper-nav {
  position: fixed;
  top: 88px;
  left: 0;
  z-index: 999;
  background-color: #ffffff;
  width: 100%;
  height: 88px;
  align-items: center;
}
  .tabs-wrapper {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 88px;
}
.bottom-line{
  margin-left: 25px;
  margin-right: 25px;
}
.tab {
  display: flex;
  flex: 1;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
//   line-height: 88px;
  // height: 88px;
}
.tabB {
  position: relative;
  top: 10px;
  width: 30px;
  height: 6px;
  border-radius: 3px;
}
.tab-selected {
  color: #000!important;
  font-weight: bold;
}
.tabB-selected {
  background-color: #ff4400;
}
.nav-link {
  color: #000;
  text-decoration: none;
  // line-height: 88px;
}
.tab-selected .nav-link {
  color: #000!important;
  font-weight: bold;
}
.userNGuide{
    opacity: 0.96;
    position: absolute;
    z-index: 999999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
    left: 100px;
    top: 88px;
  }
  .userNGuideTri{
    position: absolute;
    background: #34374A;
    transform: rotate(45deg);
    transform-origin: center;
    width: 40px;
    height: 40px;
    left: 100px;
    top: -5px;
    border-radius: 6px;
  }
  .userNGuideSep{
    height: 25px;
  }
  .userNGuideCont{
    z-index: 99;
    background: #34374A;
    border-radius: 10px;
    padding-top: 20px;
    padding-bottom: 20px;
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .userNGuideText2{
    padding-left: 40px;
    padding-right: 40px;
    font-size: 28px;
    color: #ffffff;
    line-height: 44px;
  }
  .userNGuideText{
    padding-left: 40px;
    padding-right: 40px;
    font-size: 30px;
    color: #ffffff;
    line-height: 44px;
  }
  /* 设置持续时间和动画函数 */
  .slide-fade-NGuide-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-NGuide-enter
  /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translate(-12px, -26px) scale(0.8);
    opacity: 0.5;
  }
</style>
